import routes from 'app/test/routes';

export default {
  routes,
};
